import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your live publishable key
const stripePromise = loadStripe('pk_live_51RNjVvCGUb9rmlM5ETXp3zb2afzzyViXL9MGuOqqQmgw3eiC9OrkwjkS7FMgWRjPUKEjBLkfFbxBhWUxCabA7ySC00XJw1dh0b');

// Product IDs from Stripe
const PRODUCT_IDS = {
  SHIRT: 'prod_SIKRnwGyFvQvfM',
  HOODIE: 'prod_SIKSxAiX9mBSrm',
  MUG: 'prod_SIKTcVk7cyPZqd',
  BEANIE: 'prod_SIKUvr9syh5wpi',
  STICKER: 'prod_SIKUH9ghWyVwHd'
};

// Map your local product IDs to Stripe product IDs
const productMap = {
  1: PRODUCT_IDS.SHIRT,   // T-shirt
  2: PRODUCT_IDS.HOODIE,  // Hoodie
  3: PRODUCT_IDS.MUG,     // Mug
  4: PRODUCT_IDS.BEANIE,  // Beanie
  5: PRODUCT_IDS.STICKER  // Sticker
};

const StripeCheckout = ({ cartItems }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleCheckout = async () => {
    try {
      setIsLoading(true);
      console.log('Starting checkout process...');
      console.log('Cart items:', cartItems);
      
      const stripe = await stripePromise;
      console.log('Stripe loaded successfully');
      
      // Create line items for checkout
      const lineItems = cartItems.map(item => {
        const stripeProductId = productMap[item.id];
        
        if (!stripeProductId) {
          console.error(`No product ID found for item ${item.id}`);
          return null;
        }
        
        const lineItem = {
          price_data: {
            currency: 'usd',
            product: stripeProductId,
            unit_amount: Math.round(item.price * 100), // Convert to cents
          },
          quantity: item.quantity,
        };
        
        console.log(`Created line item for product ${item.id}:`, lineItem);
        return lineItem;
      }).filter(item => item !== null);
      
      console.log('Prepared line items:', lineItems);
      
      if (lineItems.length === 0) {
        console.error('No valid line items to checkout');
        alert('There was an issue with your cart items. Please try again.');
        setIsLoading(false);
        return;
      }
      
      // Redirect to Stripe Checkout
      console.log('Redirecting to Stripe Checkout...');
      const { error } = await stripe.redirectToCheckout({
        mode: 'payment',
        line_items: lineItems,
        success_url: `${window.location.origin}/success`,
        cancel_url: `${window.location.origin}/cancel`,
        shipping_address_collection: {
          allowed_countries: ['US', 'CA'],
        },
        billing_address_collection: 'required',
        submit_type: 'pay',
      });
      
      if (error) {
        console.error('Stripe Error:', error);
        alert('There was an issue processing your payment: ' + error.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error in checkout process:', error);
      alert('There was an issue processing your payment. Please try again.');
      setIsLoading(false);
    }
  };
  
  return (
    <button 
      className="checkout-btn" 
      onClick={handleCheckout}
      disabled={cartItems.length === 0 || isLoading}
    >
      {isLoading ? 'Processing...' : 'Proceed to Checkout'}
    </button>
  );
};

export default StripeCheckout;
